// // This file can be replaced during build by using the `fileReplacements` array.
// // `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// // The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: true,
//   //baseUrl: 'http://localhost:4200',
//   firebase: {
//     apiKey: "AIzaSyBES6qV_dJEbe629i98FZTn0TXvhJUBR3Q",
//     authDomain: "playbotscmslab.firebaseapp.com",
//     databaseURL: "https://playbotscmslab.firebaseio.com",
//     projectId: "playbotscmslab",
//     storageBucket: "playbotscmslab.appspot.com",
//     messagingSenderId: "216001838451",
//     appId: "1:216001838451:web:5c1b50f5f81687188c9906",
//     measurementId: "G-SV21LDW2R2"
//   },
//   // PRO key deprecated
//   // siteKey: '6LfdmtMbAAAAALPtZ9V3om8MtxYZH3OiaYmucw92',
//   // testin key
//   // siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',

//   // Valid key for PRO
//   siteKey: '6LcWDu4bAAAAAAVJHTWq-zEGXu7q2iDcqz6hYcA2',
//   redsys: {
//     urlPasarela: 'https://sis-t.redsys.es:25443/sis/realizarPago',
//     dsSignatureVersion: 'HMAC_SHA256_V1',
//     URLREDSYS: 'https://sis-t.redsys.es:25443/sis/realizarPago',
//     URL_SUCCESS: 'https://playbots-areadeltutorlab.web.app/resultok/{idtutor}',
//     CODIGO_FUG_COMERCIO: '999008881',
//     SECRET_COD: 'sq7HjrUOBfKmC576ILgskD5srU870gJ7'
//   }
// };

export const environment = {
  production: true,
  baseUrl: 'http://playbots.es',
  firebase: {
    apiKey: "AIzaSyDHo5HNiveK8oq0UMUbDDTZRTie_Cbmres",
    authDomain: "playbotscms.firebaseapp.com",
    databaseURL: "https://playbotscms.firebaseio.com",
    projectId: "playbotscms",
    storageBucket: "playbotscms.appspot.com",
    messagingSenderId: "833577007603",
    appId: "1:833577007603:web:e0748674638559f5ed7a86",
    measurementId: "G-4E64B5R949"
  },
  siteKey: '6LcWDu4bAAAAAAVJHTWq-zEGXu7q2iDcqz6hYcA2',
  redsys: {
    urlPasarela: 'https://sis.redsys.es/sis/realizarPago',
    dsSignatureVersion: 'HMAC_SHA256_V1',
    URLREDSYS: 'https://sis.redsys.es/sis/realizarPago',
    URL_SUCCESS: 'https://playbots-areadeltutor.web.app/resultok/{idtutor}',
    CODIGO_FUG_COMERCIO: '34820753',
    SECRET_COD: 'bjFpfWkzoi4bm97VbHA/Ge1M+iUZQ8o5'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
